document.addEventListener("DOMContentLoaded", () => {

    let shareModal = new bootstrap.Modal(document.getElementById('shareModal'));

    document.body.addEventListener("click", function (e) {

        let listingID = e.target.dataset.listingid;

        if (e.target.classList.contains('listing-card-heart-white')) {
            fetch('/api/wishlistadd?listingid=' + listingID)
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    if (json.status === 'success') {
                        e.target.parentElement.classList.add('in-wishlist');
                        Toastify({
                            text: "Added to your wishlist, click to view",
                            destination: "/wishlist",
                        }).showToast();
                    }
                });
        } else if (e.target.classList.contains('listing-card-heart-red')) {
            fetch('/api/wishlistremove?listingid=' + listingID)
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    if (json.status === 'success') {
                        e.target.parentElement.classList.remove('in-wishlist');

                        Toastify({
                            text: "Removed from your wishlist",
                        }).showToast();

                        if (e.target.classList.contains('listing-card-heart-red-hide-after-remove')) {
                            let elementToHide = document.getElementById(e.target.dataset.columnid);

                            elementToHide.style.opacity = '0';

                            setTimeout(() => {

                                elementToHide.classList.add('d-none');
                                let visibleListings = false;

                                let visibleWishlistWrappers = document.querySelectorAll(".wishlist-wrapper");

                                visibleWishlistWrappers.forEach(function (elem) {
                                    if (elem.classList.contains('d-none') === false) {
                                        visibleListings = true;
                                    }
                                });

                                if (visibleListings === false) {
                                    let wishlistEmpty = document.getElementById('wishlistEmpty');
                                    if (wishlistEmpty !== undefined) {
                                        wishlistEmpty.classList.remove('d-none');
                                    }
                                }

                            }, "500");
                        }
                    }
                });
        } else if (e.target.classList.contains('listing-card-share-trigger')) {
            shareModal.show();
        }
    });
});